export default {
  computed: {
    validationDictionary () {
      // Update validator dictionary with any custom validation messages
      let dictionary = { en: { custom: {} } }
      dictionary.en.custom[this.name] = {}
      // If a string is provided, use that for all rules
      if (typeof this.errorMessages === 'string') {
        Object.keys(this.$validator.rules).forEach(function (rule) {
          dictionary.en.custom[this.name][rule] = this.errorMessages
        }.bind(this))
      } else if (typeof this.errorMessages === 'object') {
        dictionary.en.custom[this.name] = this.errorMessages
      }

      return dictionary
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/mixins/validationDictionary.js